/**
 * SmartAds — Deferred Section Loader
 * Uses IntersectionObserver to lazy-load below-fold PDP sections.
 * Sections with class `sa-deferred-section` get observed.
 * Once in viewport (+ rootMargin), they receive `is-loaded` class
 * which triggers their CSS fade-in animation.
 */
(() => {
  const reveal = (el) => {
    if (el && el.classList) el.classList.add('is-loaded');
  };

  if (!('IntersectionObserver' in window)) {
    /* Fallback: just show everything immediately */
    document.querySelectorAll('.sa-deferred-section').forEach(reveal);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-loaded');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: '150px 0px',
      threshold: 0.01,
    }
  );

  const init = () => {
    document.querySelectorAll('.sa-deferred-section').forEach((el) => {
      observer.observe(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /**
   * Theme editor only:
   * The IntersectionObserver above runs once on initial page load. When the
   * editor re-renders or selects a section while you edit its settings, that
   * fresh section element is never observed and never gets `is-loaded`, so it
   * stays at opacity 0 (blank/white) until a full page reload. Here we reveal
   * such sections immediately. This block does nothing on the live storefront.
   */
  if (window.Shopify && window.Shopify.designMode) {
    const revealFromEvent = (event) => {
      const target = event && event.target;
      if (!target) return;
      reveal(target);
      if (target.querySelectorAll) {
        target.querySelectorAll('.sa-deferred-section').forEach(reveal);
      }
    };

    document.addEventListener('shopify:section:load', revealFromEvent);
    document.addEventListener('shopify:section:select', revealFromEvent);
  }
})();